import React from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

import View from "../View";
import Link from "../Link";
import Styles from "./Styles.module.scss";
import classnames from "classnames";

import intl from "react-intl-universal";
import { IStore } from "redux/reducer_types";

const xtx = (str: string, key?: string) => intl.get(key || str || "x") || str;

declare interface IFooter {
    className?: string;
    style?: React.CSSProperties;
    isPublic?: boolean;
}

const Footer: React.FC<IFooter> = ({ className, style, isPublic }) => {
    let history = useHistory();
    useSelector((state: IStore) => state.app.language);

    const prefix = isPublic ? "/legal/public" : "/legal";

    return (
        <View
            className={classnames(Styles.footerWidget, className || "")}
            style={style || {}}
            type="flex"
            direction="row"
        >
            {isPublic ? (
                <Link onClick={() => history.push(`/, "pushed_from_app"`)}>
                    <span className={Styles.linkText}>
                        {xtx("Sign in / Register", "footer.sign_in")}
                    </span>
                </Link>
            ) : (
                <></>
            )}
            <Link
                onClick={() =>
                    history.push(`${prefix}/about`, "pushed_from_app")
                }
            >
                <span className={Styles.linkText}>
                    {xtx("About", "footer.about")}
                </span>
            </Link>
            <Link
                onClick={() =>
                    history.push(`${prefix}/contact`, "pushed_from_app")
                }
            >
                <span className={Styles.linkText}>
                    {xtx("Contact", "footer.contact")}
                </span>
            </Link>
            <Link
                onClick={() =>
                    history.push(`${prefix}/privacypolicy`, "pushed_from_app")
                }
            >
                <span className={Styles.linkText}>
                    {xtx("Privacy Policy", "footer.privacy")}
                </span>
            </Link>
            <Link
                onClick={() =>
                    history.push(`${prefix}/cookiepolicy`, "pushed_from_app")
                }
            >
                <span className={Styles.linkText}>
                    {xtx("Cookie Policy", "footer.cookies")}
                </span>
            </Link>
            <Link
                onClick={() =>
                    history.push(`${prefix}/termsofuse`, "pushed_from_app")
                }
            >
                <span className={Styles.linkText}>
                    {xtx("Terms of Use", "footer.terms")}
                </span>
            </Link>
            <Link
                onClick={() =>
                    history.push(
                        `${prefix}/fairprocessingnotice`,
                        "pushed_from_app"
                    )
                }
            >
                <span className={Styles.linkText}>
                    {xtx("Fair Processing Notice", "footer.fair_processing")}
                </span>
            </Link>
        </View>
    );
};

export default Footer;
